import styled from '@emotion/styled'

interface ReactiveProps {
  width?: string
  height?: string
  mr?: string
}

export const ReactiveWrapper = styled.div<ReactiveProps>`
  position: relative;
  ${({ mr }) => mr && `margin-right: ${mr}px`};
  width: ${({ width = '100%' }) => width};

  &::before {
    content: '';
    display: block;
    padding-top: ${({ height = '100%' }) => height};
  }

  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
